import { useWSModal } from "@wingspanhq/fe-component-library";
import { InternalNotesModal } from ".";

export function useInternalNotesModal() {
  return useWSModal(InternalNotesModal, {
    title: "Edit internal notes",
    size: "S"
  });
}
